import React from "react";
import Styles from "./Styles.module.css";
import Slider4 from "./programsliders/Slider4";
import SkeletonDisplay from "../hooks/skeletonDisplay";

function EconomicEmpowermentandClimateChange() {
  return (
    <div>
      <div className={Styles.slider1}>
        <div className={Styles.mainContainer}>
          <SkeletonDisplay>
            <img src="/aboutus/aboutus.png" alt="Curd Africa" />
          </SkeletonDisplay>
          <button>Economic empowerment and Climate Change</button>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <Slider4 />
      </div>
    </div>
  );
}

export default EconomicEmpowermentandClimateChange;
